/* Cosmova – content sections: scroll hero (sticky + overlap + media card), parallax, reveal, before/after,
   hotspots, get-the-look, press logos, quiz, store map, wishlist / compare / recently viewed pages. Requires theme.js. */
(function () {
  'use strict';
  var C = window.Cosmova; if (!C) return;
  var qs = C.qs, qsa = C.qsa, on = C.on;
  var scrollFns = [];
  var tick = false;
  function runScroll() { scrollFns.forEach(function (fn) { fn(); }); tick = false; }
  on(window, 'scroll', function () { if (!tick) { tick = true; requestAnimationFrame(runScroll); } }, { passive: true });
  on(window, 'resize', C.debounce(function () { measureHeroes(); runScroll(); }, 120));
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  /* ------------------------------------------------ Hero: sticky background & copy, parallax floats,
     rounded media card that scales + changes radius while it passes under the copy, and the next
     sections sliding over the still background (which blurs). Static when reduced motion is requested. */
  var heroes = [];
  function measureHeroes() {
    heroes.forEach(function (h) {
      var overlap = 0;
      h.overSections.forEach(function (s) { overlap += s.offsetHeight; });
      h.el.style.setProperty('--overlap', overlap + 'px');
      h.overlap = overlap;
    });
  }
  function initHero(scope) {
    qsa('[data-hero]', scope).forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      if (C.reduceMotion || !el.classList.contains('hero--scroll')) { el.classList.add('hero--static'); return; }
      var n = parseInt(el.getAttribute('data-overlap'), 10) || 0;
      var over = [], sec = el.closest('.shopify-section');
      for (var s = sec && sec.nextElementSibling; s && over.length < n; s = s.nextElementSibling) { if (s.classList.contains('shopify-section')) { s.classList.add('is-over-hero'); over.push(s); } }
      var h = { el: el, overSections: over, bg: qs('[data-hero-bg]', el), card: qs('[data-hero-card]', el), floats: qsa('[data-float-speed]', el), blur: el.getAttribute('data-blur') === 'true', overlap: 0 };
      heroes.push(h);
      el.classList.add('hero--enhanced');
      measureHeroes();
      if ('ResizeObserver' in window) { var ro = new ResizeObserver(C.debounce(measureHeroes, 80)); over.forEach(function (o) { ro.observe(o); }); }
      scrollFns.push(function () {
        var r = el.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom + h.overlap < -50 || r.top > vh) return;
        var y = -r.top;
        h.floats.forEach(function (f) {
          if (f.contains(h.card)) return;
          var sp = (parseFloat(f.getAttribute('data-float-speed')) || 5) - 5;
          f.style.transform = 'translate3d(0,' + (-y * sp * 0.06).toFixed(1) + 'px,0)';
        });
        if (h.card) {
          var cr = h.card.getBoundingClientRect();
          var center = (cr.top + cr.height / 2 - vh / 2) / vh; // 0 when card is centred
          var k = clamp(1 - Math.abs(center), 0, 1);
          h.card.style.setProperty('--card-scale', (0.82 + 0.18 * k).toFixed(3));
          h.card.style.setProperty('--card-radius', (48 - 24 * k).toFixed(1) + 'px');
        }
        if (h.blur && h.bg && h.overlap) {
          var into = clamp((y - (r.height - vh)) / Math.max(1, Math.min(h.overlap, vh)), 0, 1);
          var last = h.overSections[h.overSections.length - 1];
          var lastTop = last ? last.getBoundingClientRect().top : vh;
          var b = clamp(1 - lastTop / vh, 0, 1);
          h.bg.style.setProperty('--hero-blur', (Math.max(into * 2, b * 14)).toFixed(1) + 'px');
        }
      });
    });
  }

  /* ------------------------------------------------ Parallax + reveal */
  function initParallax(scope) {
    qsa('[data-parallax]', scope).forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0;
      if (C.reduceMotion || !speed) return;
      scrollFns.push(function () {
        var r = el.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < -100 || r.top > vh + 100) return;
        var c = clamp((r.top + r.height / 2 - vh / 2) / vh, -1, 1);
        el.style.transform = 'translate3d(0,' + (c * speed * 22).toFixed(1) + 'px,0)';
      });
    });
    if (document.body.classList.contains('has-animations') && 'IntersectionObserver' in window && !C.reduceMotion) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      qsa('.main-content .shopify-section:not(:first-child):not(.is-over-hero) .section > .container', scope).forEach(function (el) {
        if (el.classList.contains('reveal')) return;
        if (el.getBoundingClientRect().top < window.innerHeight) return;
        el.classList.add('reveal'); io.observe(el);
      });
    }
  }


  /* ------------------------------------------------ Background video: poster first, mp4 attached later */
  function initBgVideo(scope) {
    qsa('video[data-bg-video]', scope).forEach(function (v) {
      if (v.dataset.ready) return; v.dataset.ready = '1';
      var src = v.getAttribute('data-bg-video'); if (!src) return;
      var conn = navigator.connection || {};
      if (conn.saveData || C.reduceMotion) return; // poster only
      var started = false;
      function start() {
        if (started) return; started = true;
        v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
        var s = document.createElement('source'); s.src = src; s.type = 'video/mp4'; v.appendChild(s);
        v.preload = 'auto'; v.muted = true; v.load();
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      }
      var small = window.matchMedia('(max-width: 989px)').matches;
      var go = function () { if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 3000 }); else setTimeout(start, 1500); };
      var after = function () { if (document.readyState === 'complete') go(); else on(window, 'load', go); };
      if (small) {
        ['touchstart', 'scroll', 'pointerdown', 'keydown'].forEach(function (ev) { on(window, ev, start, { once: true, passive: true }); });
        setTimeout(function () { after(); }, 6000);
      } else after();
    });
  }

  function initBeforeAfter(scope) {
    qsa('[data-before-after]', scope).forEach(function (ba) {
      if (ba.dataset.ready) return; ba.dataset.ready = '1';
      var range = qs('[data-before-after-range]', ba);
      on(range, 'input', function () { ba.style.setProperty('--pos', range.value + '%'); });
    });
  }

  function initLook(scope) {
    qsa('[data-accordion-tabs]', scope).forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      on(wrap, 'click', function (e) {
        var tab = e.target.closest('[data-look-tab]'); if (!tab) return;
        qsa('[data-look-tab]', wrap).forEach(function (t) {
          var open = t === tab;
          t.setAttribute('aria-expanded', String(open));
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !open;
        });
      });
    });
  }

  on(document, 'click', function (e) {
    var btn = e.target.closest('.hotspot__btn');
    var spot = btn && btn.closest('[data-hotspot]');
    qsa('.hotspot.is-open').forEach(function (h) { if (h !== spot && !h.contains(e.target)) { h.classList.remove('is-open'); qs('.hotspot__btn', h).setAttribute('aria-expanded', 'false'); } });
    if (spot) { var open = spot.classList.toggle('is-open'); btn.setAttribute('aria-expanded', String(open)); }
  });

  /* ------------------------------------------------ Press logos: click/auto-rotate the quote */
  function initLogos(scope) {
    qsa('[data-logo-list]', scope).forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var logos = qsa('[data-logo-index]', wrap), quotes = qsa('[data-logo-quote]', wrap), i = 0, paused = false;
      if (!quotes.length) return;
      function show(n) { i = (n + logos.length) % logos.length; logos.forEach(function (l, k) { l.classList.toggle('is-active', k === i); l.setAttribute('aria-pressed', String(k === i)); }); quotes.forEach(function (q) { var on_ = +q.getAttribute('data-logo-quote') === i; q.hidden = !on_; q.classList.toggle('is-active', on_); }); }
      on(wrap, 'click', function (e) { var l = e.target.closest('[data-logo-index]'); if (l) { paused = true; show(+l.getAttribute('data-logo-index')); } });
      if (!C.reduceMotion) setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, 5000);
    });
  }

  /* ------------------------------------------------ Quiz: step through questions, tally results */
  function initQuiz(scope) {
    qsa('[data-quiz]', scope).forEach(function (quiz) {
      if (quiz.dataset.ready) return; quiz.dataset.ready = '1';
      var intro = qs('[data-quiz-step="intro"]', quiz), stepsWrap = qs('[data-quiz-steps]', quiz), results = qs('[data-quiz-results]', quiz);
      var steps = qsa('fieldset[data-quiz-step]', quiz), bar = qs('[data-quiz-progress]', quiz), answers = [], cur = 0;
      function show(i) {
        cur = i; steps.forEach(function (s, n) { s.hidden = n !== i; });
        if (bar) bar.style.width = (i / steps.length * 100) + '%';
        var f = qs('[data-quiz-answer]', steps[i]); if (f) f.focus({ preventScroll: true });
      }
      function finish() {
        var score = {};
        answers.forEach(function (r) { score[r] = (score[r] || 0) + 1; });
        var best = Object.keys(score).sort(function (a, b) { return score[b] - score[a] || a - b; })[0] || '1';
        stepsWrap.hidden = true; results.hidden = false;
        var res = qsa('[data-quiz-result]', quiz), match = qs('[data-quiz-result="' + best + '"]', quiz) || res[0];
        res.forEach(function (r) { r.hidden = r !== match; });
        if (match) { var h = qs('h2', match); if (h) { h.tabIndex = -1; h.focus(); } }
        C.store('cosmova-quiz', best);
      }
      on(qs('[data-quiz-start]', quiz), 'click', function () { intro.hidden = true; stepsWrap.hidden = false; answers = []; show(0); });
      on(quiz, 'click', function (e) {
        var a = e.target.closest('[data-quiz-answer]');
        if (a) { answers[cur] = a.getAttribute('data-result'); if (cur + 1 < steps.length) show(cur + 1); else finish(); return; }
        if (e.target.closest('[data-quiz-back]')) { show(Math.max(0, cur - 1)); return; }
        if (e.target.closest('[data-quiz-restart]')) { results.hidden = true; stepsWrap.hidden = false; answers = []; show(0); }
      });
      if (window.Shopify && window.Shopify.designMode) { intro.hidden = true; stepsWrap.hidden = false; show(0); }
    });
  }

  /* ------------------------------------------------ Store locator: map loads only after consent click */
  function initStores(scope) {
    qsa('[data-store-locator]', scope).forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var mapBox = qs('.store-locator__map', wrap), loaded = false;
      function load(q) {
        var iframe = qs('iframe', mapBox);
        var src = 'https://maps.google.com/maps?q=' + q + '&z=15&output=embed';
        if (!iframe) { iframe = document.createElement('iframe'); iframe.loading = 'lazy'; iframe.title = (C.strings.map || 'Map'); iframe.referrerPolicy = 'no-referrer-when-downgrade'; mapBox.innerHTML = ''; mapBox.appendChild(iframe); }
        iframe.src = src; loaded = true;
      }
      on(wrap, 'click', function (e) {
        var b = e.target.closest('[data-map-load]');
        if (b) { var a = qs('.store-card.is-active', wrap); load(a ? a.getAttribute('data-store-map') : ''); return; }
        var card = e.target.closest('[data-store-map]');
        if (card) {
          qsa('[data-store-map]', wrap).forEach(function (c) { c.classList.toggle('is-active', c === card); c.setAttribute('aria-pressed', String(c === card)); });
          if (loaded) load(card.getAttribute('data-store-map'));
        }
      });
    });
  }

  /* ------------------------------------------------ Product cards fetched via Section Rendering API */
  var cardCache = {};
  function fetchCard(handle) {
    if (cardCache[handle]) return cardCache[handle];
    cardCache[handle] = C.fetchText((C.routes.root || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '?section_id=card-product')
      .then(function (html) { var f = qs('.card-product-fragment', C.parseHTML(html)); return f ? f.innerHTML : ''; })
      .catch(function () { return ''; });
    return cardCache[handle];
  }
  function fillGrid(grid, handles, wrapItem) {
    return Promise.all(handles.map(fetchCard)).then(function (cards) {
      grid.innerHTML = cards.filter(Boolean).map(function (c) { return wrapItem ? '<div>' + c + '</div>' : c; }).join('');
      C.initScope(grid);
      return cards.filter(Boolean).length;
    });
  }
  function initWishlistPage(scope) {
    qsa('[data-wishlist-grid]', scope).forEach(function (grid) {
      if (grid.dataset.ready) return; grid.dataset.ready = '1';
      var sec = grid.closest('.section'), empty = qs('[data-wishlist-empty]', sec), actions = qs('[data-wishlist-actions]', sec);
      function render() {
        var list = C.getList('cosmova-wishlist');
        if (!list.length) { grid.innerHTML = ''; empty.hidden = false; actions.hidden = true; return; }
        empty.hidden = true; actions.hidden = false;
        fillGrid(grid, list);
      }
      on(qs('[data-wishlist-clear]', sec), 'click', function () { C.store('cosmova-wishlist', []); C.syncWishlist(); render(); });
      on(document, 'wishlist:change', function () { setTimeout(render, 200); });
      render();
    });
  }
  function initRecent(scope) {
    qsa('[data-recently-viewed]', scope).forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var list = (C.store('cosmova-recent') || []).filter(function (h) { return h !== sec.getAttribute('data-exclude'); }).slice(0, parseInt(sec.getAttribute('data-limit'), 10) || 8);
      if (!list.length) return;
      var grid = qs('[data-recently-list]', sec);
      fillGrid(grid, list, true).then(function (n) { sec.hidden = !n; });
      on(qs('[data-recently-clear]', sec), 'click', function () { C.store('cosmova-recent', []); sec.hidden = true; });
    });
  }
  function initComparePage(scope) {
    qsa('[data-compare-table]', scope).forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var sec = box.closest('.section'), empty = qs('[data-compare-empty]', sec);
      var labels = (box.getAttribute('data-labels') || 'Prezzo|Tipo|Marchio|Varianti|Disponibilità|Descrizione').split('|');
      function render() {
        var list = C.getList('cosmova-compare');
        if (!list.length) { box.innerHTML = ''; empty.hidden = false; return; }
        empty.hidden = true;
        Promise.all(list.map(function (h) { return fetch((C.routes.root || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
          .then(function (ps) {
            ps = ps.filter(Boolean);
            var e = C.escapeHtml;
            var row = function (label, fn) { return '<tr><th scope="row">' + e(label) + '</th>' + ps.map(function (p) { return '<td>' + fn(p) + '</td>'; }).join('') + '</tr>'; };
            var html = '<table class="compare-table"><thead><tr><td></td>' + ps.map(function (p) {
              var img = p.featured_image ? '<img src="' + e(p.featured_image) + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy" width="200" height="250">' : '';
              return '<th scope="col"><a href="' + e(p.url) + '" class="compare-table__product"><span class="compare-table__img">' + img + '</span><span>' + e(p.title) + '</span></a><button type="button" class="link text-small" data-compare-toggle="' + e(p.handle) + '">' + e(box.getAttribute('data-remove')) + '</button></th>';
            }).join('') + '</tr></thead><tbody>';
            html += row(labels[0], function (p) { return '<strong>' + e(C.formatMoney(p.price)) + '</strong>' + (p.compare_at_price > p.price ? ' <s class="text-soft">' + e(C.formatMoney(p.compare_at_price)) + '</s>' : ''); });
            html += row(labels[1], function (p) { return e(p.type || '—'); });
            html += row(labels[2], function (p) { return e(p.vendor || '—'); });
            html += row(labels[3], function (p) { return (p.options || []).map(function (o) { return '<strong>' + e(o.name) + ':</strong> ' + e((o.values || []).join(', ')); }).join('<br>'); });
            html += row(labels[4], function (p) { return p.available ? '<span class="stock stock--in">' + e(box.getAttribute('data-yes')) + '</span>' : '<span class="stock stock--out">' + e(box.getAttribute('data-no')) + '</span>'; });
            html += row(labels[5], function (p) { var d = document.createElement('div'); d.innerHTML = p.description || ''; return e((d.textContent || '').trim().slice(0, 180)) + '…'; });
            html += row('', function (p) { var v = (p.variants || []).filter(function (x) { return x.available; })[0]; return v ? (p.variants.length > 1 ? '<button type="button" class="btn btn--small" data-quick-view="' + e(p.url) + '">' + e(box.getAttribute('data-add')) + '</button>' : '<button type="button" class="btn btn--small" data-quick-add="' + v.id + '">' + e(box.getAttribute('data-add')) + '</button>') : '<button type="button" class="btn btn--small" disabled>' + e(box.getAttribute('data-soldout')) + '</button>'; });
            box.innerHTML = html + '</tbody></table>';
          });
      }
      on(document, 'compare:change', render);
      render();
    });
  }

  C.register(function (scope) {
    initHero(scope); initBgVideo(scope); initParallax(scope); initBeforeAfter(scope); initLook(scope); initLogos(scope);
    initQuiz(scope); initStores(scope); initWishlistPage(scope); initRecent(scope); initComparePage(scope);
    runScroll();
  });
})();
